var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"mb-10 pa-3"},[_c('info-box',{attrs:{"label":_vm.$t('rentals.allRentals'),"value":_vm.recordCount}})],1),_c('div',{staticClass:"page-body"},[_c('rentals-table',{attrs:{"data":_vm.rentals}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }